import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    PreconditioningTechnology,
    StorageType,
} from 'app/enums/label.enums'
import {
    StorageTableType,
} from '../../../serviceCenters.types'

const LocationFormServiceCenterMetricsFields = ({
    getAllowedValues,
    storageType,
}: {
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
    storageType: StorageType,
}): DTOCardFormField<keyof StorageTableType>[] => {
    return [{
        id: 'storage',
        title: 'General',
        className: 'storage',
        fields: [
            {
                id: 'column1',
                fields: [{
                    name: 'storageType',
                    componentName: 'EnumSelector',
                    allowedValues: getAllowedValues(StorageType),
                    required: true,
                    labelKey: 'ServiceCenterStorage.storageType',
                }],
            },
            {
                id: 'column2',
                fields: [{
                    name: 'storageCapacity',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'ServiceCenterStorage.storageCapacity',
                }],
            },
            {
                id: 'column3',
                fields: [{
                    name: 'preconditioningTechnology',
                    componentName: 'EnumSelector',
                    allowedValues: getAllowedValues(PreconditioningTechnology),
                    required: true,
                    useDropdown: true,
                    disabled: storageType === StorageType.DRY,
                    labelKey: 'ServiceCenterStorage.preconditioningTechnology',
                }],
            },
            {
                id: 'column4',
                fields: [{
                    name: 'preconditioningCapacity',
                    componentName: 'IntegerInput',
                    required: true,
                    disabled: storageType === StorageType.DRY,
                    labelKey: 'ServiceCenterStorage.preconditioningCapacity',
                }],
            },
        ],
    }]
}

export default LocationFormServiceCenterMetricsFields
